import { API, Card, Endpoints, TFile } from "@brg/api";
import queryString from 'query-string'
import { FC, useCallback, useMemo } from "react";
import { GoodItem, GoodsWrapper, Price, SmallImage, Title, TitleWrapper, ActionWrapper, ImageWrapper, ItemNameWrapper } from "./style";
import { useTranslation } from "react-i18next";
import { useResizedImageEnhanced } from "shared/hooks/useResizedImageEnhanced";
import DeleteIcon from "shared/icons/DeleteIcon";
import { useReproductionCards } from "shared/modals/CardSelectModal/ReproductionSelectModal";
import { useProfile } from "@brg/auth";
import EditIcon24 from "shared/icons/EditIcon24";

interface GoodProps {
    id: string,
    name: string,
    price: number,
    images: TFile[],
    onDelete?: (id: string) => void,
    onEdit?: () => void;
}

const Item: FC<GoodProps> = ({ id, name, price, images, onDelete, onEdit }) => {

    const [image, ref] = useResizedImageEnhanced(images);

    const cardImage =`${Endpoints.files}/${image?.url}`

    return (
        <GoodItem ref={ref}>
            <ItemNameWrapper>
            <ImageWrapper>
                <SmallImage isSmall={true}>
                    {image?.url && <img src={cardImage} alt=""/>}
                </SmallImage>
            </ImageWrapper>
            <TitleWrapper justify="space-between" direction="column">
                <Title>{name}</Title>
                {/* <Price>{price}&nbsp;{'₽'}</Price> */}
            </TitleWrapper>
            </ItemNameWrapper>
            <ActionWrapper>
                <div onClick={() => onEdit && onEdit()}>
                    <EditIcon24 />
                </div>
                <div onClick={() => onDelete && onDelete(id)}>
                    <DeleteIcon/>
                </div>
            </ActionWrapper>
        </GoodItem>
    )
}


export const ReproductionList: FC<{ cardsIds?: string[], onDelete: (ids: string[], isDelete?: boolean) => void, isCalendarCard?: boolean, ignoreUserId?: boolean, onEdit?: () => void,}> = ({ cardsIds, onDelete, isCalendarCard, ignoreUserId, onEdit }) => {
    const { i18n} = useTranslation();
    const profile = useProfile();

    const cardsQueryString = useMemo(() => {
        if (cardsIds?.length) {
            const query = 
                {
                    cardIds: cardsIds,
                    isHeaderIgnored: true,
                    isLite: 'true',
                    isProduct: 'false',
                    cardOnlyImage: true,
                    status: isCalendarCard? [2, 7] : [2],
                    page: 1,
                    limit: 20,
                    ...(ignoreUserId? {} : {userIds: profile?.accountId})
                }
            // @ts-ignore
            return queryString.stringify(query)
        }

    }, [cardsIds, profile])

    const { data } = useReproductionCards(cardsQueryString)

    const computeCard = useMemo(() => API.toLang(data?.data, i18n.language) , [data]) as Card[];

    const onDeleteGoodClick = useCallback((id: string) => {
        //@ts-ignore
        const ids = computeCard?.map((card) => card?.cardId)?.filter((cardId) =>  cardId !== id)
        onDelete(ids, true)
    } , [ computeCard])
    
    
    if (!cardsIds?.length) {
        return null
    }

    return (
        <GoodsWrapper>
            {computeCard?.length && computeCard?.map((card) => {
                return (
                    /*@ts-ignore*/
                    <Item id={card?.cardId} name={card?.name} price={card?.priceInfo?.realProductPrice || 0} images={isCalendarCard? card?.titleImage : card?.images} onDelete={onDeleteGoodClick} onEdit={onEdit} />
                )
            })}
        </GoodsWrapper>
    )
}import { API, Card, Endpoints, TFile } from "@brg/api";
import queryString from 'query-string'
import { FC, useCallback, useMemo } from "react";
import { GoodItem, GoodsWrapper, Price, SmallImage, Title, TitleWrapper, ActionWrapper, ImageWrapper, ItemNameWrapper } from "./style";
import { useTranslation } from "react-i18next";
import { useResizedImageEnhanced } from "shared/hooks/useResizedImageEnhanced";
import DeleteIcon from "shared/icons/DeleteIcon";
import { useReproductionCards } from "shared/modals/CardSelectModal/ReproductionSelectModal";
import { useProfile } from "@brg/auth";
import EditIcon24 from "shared/icons/EditIcon24";

interface GoodProps {
    id: string,
    name: string,
    price: number,
    images: TFile[],
    onDelete?: (id: string) => void,
    onEdit?: () => void;
}

const Item: FC<GoodProps> = ({ id, name, price, images, onDelete, onEdit }) => {

    const [image, ref] = useResizedImageEnhanced(images);

    const cardImage =`${Endpoints.files}/${image?.url}`

    return (
        <GoodItem ref={ref}>
            <ItemNameWrapper>
            <ImageWrapper>
                <SmallImage isSmall={true}>
                    {image?.url && <img src={cardImage} alt=""/>}
                </SmallImage>
            </ImageWrapper>
            <TitleWrapper justify="space-between" direction="column">
                <Title>{name}</Title>
                {/* <Price>{price}&nbsp;{'₽'}</Price> */}
            </TitleWrapper>
            </ItemNameWrapper>
            <ActionWrapper>
                <div onClick={() => onEdit && onEdit()}>
                    <EditIcon24 />
                </div>
                <div onClick={() => onDelete && onDelete(id)}>
                    <DeleteIcon/>
                </div>
            </ActionWrapper>
        </GoodItem>
    )
}


export const ReproductionList: FC<{ cardsIds?: string[], onDelete: (ids: string[], isDelete?: boolean) => void, isCalendarCard?: boolean, ignoreUserId?: boolean, onEdit?: () => void,}> = ({ cardsIds, onDelete, isCalendarCard, ignoreUserId, onEdit }) => {
    const { i18n} = useTranslation();
    const profile = useProfile();

    const cardsQueryString = useMemo(() => {
        if (cardsIds?.length) {
            const query = 
                {
                    cardIds: cardsIds,
                    isHeaderIgnored: true,
                    isLite: 'true',
                    isProduct: 'false',
                    cardOnlyImage: true,
                    status: isCalendarCard? [2, 7] : [2],
                    page: 1,
                    limit: 20,
                    ...(ignoreUserId? {} : {userIds: profile?.accountId})
                }
            // @ts-ignore
            return queryString.stringify(query)
        }

    }, [cardsIds, profile])

    const { data } = useReproductionCards(cardsQueryString)

    const computeCard = useMemo(() => API.toLang(data?.data, i18n.language) , [data]) as Card[];

    const onDeleteGoodClick = useCallback((id: string) => {
        //@ts-ignore
        const ids = computeCard?.map((card) => card?.cardId)?.filter((cardId) =>  cardId !== id)
        onDelete(ids, true)
    } , [ computeCard])
    
    
    if (!cardsIds?.length) {
        return null
    }

    return (
        <GoodsWrapper>
            {computeCard?.length && computeCard?.map((card) => {
                return (
                    /*@ts-ignore*/
                    <Item id={card?.cardId} name={card?.name} price={card?.priceInfo?.realProductPrice || 0} images={isCalendarCard? card?.titleImage : card?.images} onDelete={onDeleteGoodClick} onEdit={onEdit} />
                )
            })}
        </GoodsWrapper>
    )
}